import { createFileRoute, useParams } from '@tanstack/react-router';

import {
  MyCertificationDetailContent,
  useGetMyBaseCertificationDetail,
} from '../../../../-shared';

export const Route = createFileRoute(
  '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/',
)({
  component: MyBaseCertificationDetail,
});

function MyBaseCertificationDetail() {
  const { id } = useParams({
    from: '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/',
  });
  const queryResult = useGetMyBaseCertificationDetail(id);
  return <MyCertificationDetailContent {...queryResult} />;
}
